import { FC, Fragment } from 'react';

import classNames from 'classnames';
import { Permissions } from 'utils/constants/permissions';

import { Link } from '@hh.ru/redux-spa-middleware';

import ClickMenu, { MenuPlacement } from 'bloko/blocks/drop/Menu/Click';
import BlokoLink from 'bloko/blocks/link';
import Text, { TextSize } from 'bloko/blocks/text';

import useTrl from 'hooks/translation/useTrls';

import aliases, { moderation, reports } from 'components/Admin/SectionTabs/aliases';
import Content from 'components/Admin/SectionTabs/Content/Content';

import { useSelector } from 'store/utils';

import styles from 'components/Admin/SectionTabs/SectionTabs.module.less';

const SectionTabs: FC = () => {
    const permissions = useSelector((state) => state.user.permissions);

    const trl = useTrl();

    return (
        <div className={styles.sectionTabs}>
            {aliases.map(({ code, path, permission, dataQa }) => (
                <Fragment key={code}>
                    {permissions.includes(permission) && (
                        <div
                            className={classNames(
                                styles.sectionTabsItem,
                                document.location.pathname === path && styles.sectionTabsItemActive
                            )}
                            data-qa={dataQa}
                        >
                            <BlokoLink Element={Link} to={path} disableVisited>
                                <Text size={TextSize.Large}>{trl(`admin.SectionTabs.${code}`)}</Text>
                            </BlokoLink>
                        </div>
                    )}
                </Fragment>
            ))}
            {permissions.includes(Permissions.ViewAdminReports) && (
                <ClickMenu
                    render={() => <Content permissions={permissions} data={reports} />}
                    placement={MenuPlacement.BottomEnd}
                >
                    <div className={styles.sectionTabsItem}>
                        <Text size={TextSize.Large}>{trl('admin.SectionTabs.reports')}</Text>
                    </div>
                </ClickMenu>
            )}
            {permissions.includes(Permissions.ViewModeration) && (
                <ClickMenu
                    render={() => <Content permissions={permissions} data={moderation} />}
                    placement={MenuPlacement.BottomEnd}
                >
                    <div className={styles.sectionTabsItem}>
                        <Text size={TextSize.Large}>{trl('admin.SectionTabs.moderation')}</Text>
                    </div>
                </ClickMenu>
            )}
        </div>
    );
};

export default SectionTabs;
